import { createContext } from 'react';

// Set by ConfigRoute around a threshold screen: { config: 'lcr-config' } - which threshold setup the screen edits. WarningPage reads it to show
// the "Who can set this" line under the title. Everywhere else it is null.
export const ConfigScreenContext = createContext(null);

export default ConfigScreenContext;
